import { BillingApi, Configuration } from '@/api';
import { BillingCustomerTarget, BillingPricing } from '@/models/Billing';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const getBillingPricingQueryKey = ['billing-pricing'] as const;

const useGetBillingPricingQuery = (customer?: BillingCustomerTarget) => {
  const queryClient = useQueryClient();
  const billingApi = new BillingApi(new Configuration(useAuth));

  const {
    data: pricing,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<BillingPricing[]>({
    queryKey: [getBillingPricingQueryKey[0], customer ?? null],
    queryFn: () => billingApi.getBillingPricing(customer),
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [getBillingPricingQueryKey[0], customer ?? null],
    });
  };

  return {
    pricing: pricing ?? [],
    isLoading,
    isFetching,
    error,
    refetch,
    invalidateQuery,
  };
};

export default useGetBillingPricingQuery;
